import { inspect } from 'util';
import { ActionError } from '@/backend/errors/ActionError';
import type { Formatter } from '@/backend/errors/Formatter';
import { isValidationError } from '@/backend/errors/isValidationError';

export function prettyPrint(item: unknown, printer: Formatter) {
  if (!item) {
    return JSON.stringify(item) ?? 'undefined';
  }
  if (isValidationError(item) || item instanceof ActionError) {
    return item.format(printer);
  }
  if (item instanceof Error) {
    return item.stack ?? item.message;
  }
  if (item instanceof Date) {
    return item.toISOString();
  }
  if (typeof item === 'string') {
    return item;
  }

  return inspect(item, { depth: 4 });
}
